import classNames from 'classnames'
import React from 'react'
import useIsTablet from '../../modules/hooks/common/useIsTablet'
interface CircleTextBoxType {
  circle: React.ReactNode
  desc?: React.ReactNode
  clx?: string
}

const CircleTextBox: React.FC<CircleTextBoxType> = ({ circle, desc, clx }) => {
  const [isTablet, setIsTablet] = useIsTablet()
  return (
    <div className={classNames(`md:mb-0 ${clx}`, 'mb-[32px] flex flex-1 flex-col items-center justify-center')}>
      <div
        className={classNames(
          { 'w-[235px]': !isTablet },
          { 'h-[235px]': !isTablet },
          { 'w-[158px]': isTablet },
          { 'h-[158px]': isTablet },
          'text-d3 sm:test-d1 flex items-center justify-center rounded-full border border-purple-500 font-bold text-purple-500'
        )}
      >
        {circle}
      </div>
      <div className="text-h3 mt-[16px] font-medium text-purple-500">{desc}</div>
    </div>
  )
}

export default CircleTextBox
